import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomHttpParams } from '../api-handler/api-handler.service';
import { Guid } from 'guid-typescript';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';

/** This method intercepts the http request and set the headers required by Account management*/
@Injectable()
export class VcmInterceptorService implements HttpInterceptor {
  /**
  * has a dependency on domain matcher to generate a dynamic X-channel
  * DomainMatcher
  **/
  constructor(public ngRedux: NgRedux<AppState>) { }

  /**
  * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
  * @args domainMatcher
  * @returns The response that is being intercepted so it can continue to the Network call
  **/
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = {};
    if (req.params instanceof CustomHttpParams && req.params.spec) {
      switch (req.params.spec) {
        case 'get_vcm_history':
        case 'clear_vin':
        case 'clear_chip_id':
        case 'blacklist_vin':
          headers = this.getVcmHeaders(req.params.spec);
          break;
        case 'cvs_details':
          headers = this.getCVSHeaders(req.params.spec);
          break;
      }
    }
    return next.handle(req.clone({
      setHeaders: headers
    }));
  }
  /**
  *@function getPortalHeaders Return the common headers on the request
  *@returns headers of object type
  **/
  public getVcmHeaders(type): object {
    const headers = {
      'x-correlationId': Guid.create().toString(),
    };
    return headers;
  }
  /**
  *@function getCVSHeaders  Return the headers for cvs request
  *@returns headers of object type
  **/
  public getCVSHeaders(type): object {
    const headers = {
      'x-correlationid': Guid.create().toString(),
      'X-CHANNEL': 'CTP',
    };
    return headers;
  }
}
